import { render } from "./WordpressDesktop.vue?vue&type=template&id=44d0e39e"
import script from "./WordpressDesktop.vue?vue&type=script&lang=js"
export * from "./WordpressDesktop.vue?vue&type=script&lang=js"

import "./WordpressDesktop.vue?vue&type=style&index=0&id=44d0e39e&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__